// extracted by mini-css-extract-plugin
export var checkbox = "_68-0";
export var circle = "_68-3";
export var horizontalContainer = "_68-7";
export var sm = "_68-5";
export var switch0 = "_68-2";
export var switchDisabled = "_68-8";
export var switchEnabled = "_68-1";
export var textSwitchContainer = "_68-9";
export var textSwitchOption = "_68-a";
export var textSwitchOptionSelected = "_68-b";
export var verticalContainer = "_68-6";
export var xs = "_68-4";